import axiosInstance from '../../../config/axiosInstance';
const CustomerSiteService = {
    async GetAllCustomersSites(redirectCallback, ClientCompanyID) {
        try {
            const response = await axiosInstance.get(`/Customer/GetCustomerSites?ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetCustomerSiteByID(redirectCallback, ClientBranchID) {
        try {
            const response = await axiosInstance.get(`/Customer/GetCustomerSitesByID?ClientBranchID=${ClientBranchID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteCustomerSite(ID, redirectCallback) {
        try {

            const response = await axiosInstance.get(`/Customer/DeleteCustomerSite?ClientBranchID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetAllNewSites(ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllNewSites?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetCustomerSiteCount(ClientCompanyID, searchQuery, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetCustomerSiteCount?ClientID=${ClientID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default CustomerSiteService;